import { createContext } from 'react'

export interface SurveyLinkContextValue {
  rcnId?: string | number
  planId?: string | number
  planOrgId?: string | number
  priorityTaskIds: Record<number, number | undefined>
}

export const SurveyLinkContext = createContext<SurveyLinkContextValue>({
  priorityTaskIds: {}
})
